<template>
  <div class="col-12 page_content_area">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12">

          <div class="page_title">詳細資料</div>
          <div class="page_subtitle">{{ subtitle }}</div>
          <div class="portlet_wrapper">
            <div class="cnt_block">
              <div class="table_holder">
                <table>
                  <thead>
                    <tr> <th>詳細資料</th> <th>填寫/查看</th> <th>紙本檔</th> </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>學生校外實習報告</td>
                      <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('intern-report')">填寫/查看</router-link> </td>
                      <td> <router-link class="d-inline-block btn--pill pill aqua" :to="detailPath('intern-report', 'file')">上傳/下載</router-link> </td>
                    </tr>
                    <tr>
                      <td>學生滿意度調查</td>
                      <td> <router-link class="d-inline-block btn--pill pill blue" :to="detailPath('student-satisfaction')">填寫/查看</router-link> </td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="chat_room_open_btn" @click="open_chat_room()"></div>
          <div id="new_chat_room"></div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { chat_room } from '~components/common/chat_room.js'
import '~style/components/chat_room.css'
export default {
  name: 'StudentsInternEnterpriseDetailContent',
  components: {
  },
  data () {
    return {
      chat_room: null,
      student_id: null,
    }
  },
  computed: {
    ...mapGetters('auth', [
      'tokenGetters'
    ]),
    ...mapGetters('pages/students', [
      'currentStudentGetter'
    ]),
    subtitle () {
      return [this.currentStudentGetter.student_department_name, this.currentStudentGetter.student_id, this.currentStudentGetter.student_name].join(' ');
    },
  },
  created () {
  },
  async mounted () {
    this.togglePageLoader(true);
    await this.getStudentByToken();
    let el = $('#new_chat_room')[0];
    this.chat_room = new chat_room(el, {
      name: this.currentStudentGetter.student_name,
      token: this.tokenGetters,
    });
    this.student_id = this.currentStudentGetter.student_pk_id;
    this.togglePageLoader(false);
  },
  methods: {
    ...mapActions('layouts', [
      'togglePageLoader'
    ]),
    ...mapActions('pages/students', [
      'getStudentByToken',
    ]),
    open_chat_room () {
      if(this.chat_room && this.student_id) {
        this.chat_room.open(this.student_id);
      }
    },
    detailPath(form_type, edit_type) {
      let path = `/students/intern/intern-record/${this.$route.params.year}/${this.$route.params.eid}/${form_type}`;
      if(edit_type) path += `/${edit_type}`;
      return path;
    },
  }
}
</script>
<style lang="scss" scoped>
  table {
    th:first-child { text-align: left; width: 60%; padding-left: 4rem!important; }
    td:first-child { text-align: left; width: 60%; padding-left: 2rem!important; }
  }
</style>
